import DropDownSelector from "../../micro_components/DropDownSelector";
import GroupedSearchableMultiSelect from "../../micro_components/GroupedSearchableMultiSelect";
import RoleManager from "../../micro_components/RoleManager";
import { Button, TextField } from "@material-ui/core";

export default function DomainAndCategoriesSelector({
  allDomains,
  book,
  allCategories,
  selectedCategories,
  roles,
  domainCreators,
  setPageThumbModalOpen,
  description,
  setBook,
  setSelectedDomainId,
  setSelectedCategories,
  setRoles,
  setDescription,
}) {
  const possibleRoles = [
    { id: 1, name: "Composer" },
    { id: 2, name: "Arranger" },
    { id: 3, name: "Performer" },
    { id: 4, name: "Teacher" },
    { id: 5, name: "Editor" },
    { id: 6, name: "Re-creator" },
    { id: 7, name: "Writer" },
  ];

  const handleRoleUpdate = (newState) => {
    setRoles([...newState]);
  };

  const handleDomainDrop = (value) => {
    const nextDomainId = parseInt(value, 10);
    const previousDomainId = parseInt(book?.domain_id, 10);
    setBook({ ...book, domain_id: nextDomainId });
    setSelectedDomainId(nextDomainId);

    // Only clear domain-scoped data when the domain actually changes
    if (nextDomainId === previousDomainId) {
      return;
    }

    setSelectedCategories([]);
    setRoles([{ creator_id: "", title: "" }]);
  };

  const handleCategoryDrop = (e) => {
    setSelectedCategories(e);
  };

  const handleDescriptionChange = (e) => {
    console.log(description);
    setDescription(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
      }}
    >
      <div className="top-middle-section">
        {/* DOMAINS */}
        <div className="add-book-form__section">
          <div
            style={{
              display: "flex",
            }}
          >
            <div className="add-book-form__field">
              {allDomains && (
                <>
                  <h3>Domain</h3>
                  <DropDownSelector
                    data={allDomains}
                    value={book?.domain_id}
                    placeholder="Domain"
                    onChange={handleDomainDrop}
                  />
                </>
              )}
            </div>
          </div>
        </div>
        {/* CATEGORIES */}
        <div className="add-book-form__section">
          <div className="add-book-form__field">
            <h3>Categories</h3>
            <GroupedSearchableMultiSelect
              data={allCategories}
              placeholder="Search categories..."
              setValue={handleCategoryDrop}
              value={selectedCategories}
            />
          </div>
        </div>
        {/* CREATORS */}
        <div className="add-book-form__section">
          <div className="add-book-form__field">
            <h3>Creators</h3>
            <RoleManager
              rolesFromParent={roles || []}
              setRolesFromParent={handleRoleUpdate}
              possibleRoles={possibleRoles}
              creators={domainCreators}
            />
          </div>
        </div>
        <div className="add-book-form__section">
          <div className="add-book-form__field">
            <h3>Miscellaneous</h3>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setPageThumbModalOpen(true)}
            >
              Set menu dimensions
            </Button>
          </div>
        </div>
      </div>
      <div className="add-book-form__section description">
        <div className="add-book-form__field">
          <h3>Description</h3>
          <TextField
            placeholder="A few sentences about the book"
            multiline
            variant="outlined"
            minRows={8}
            maxRows={Infinity}
            value={description}
            defaultValue={description}
            onChange={handleDescriptionChange}
            fullWidth
          />
        </div>
      </div>
    </div>
  );
}
